// Header
import './js/header/header-height-adjust.js';
import './js/header/color-scheme-switcher.js';
import './js/header/burger-mobile.js';

// Fetch
import './js/components/spinner.js';

// Sidebar
import './js/support-ukraine/support.js';

// Content part
import './js/shopping-list';

// Authorization
import './js/firebase/firebase';
import './js/firebase/authservice';
import './js/firebase/firebaseservise';

import './js/modal-login/authorization-form.js';
import './js/modal-login/form-validator.js';

// Scroll-to-top button
import './js/components/back-to-top.js';
